import { useMutation } from '@tanstack/react-query';
import { POST, POST_UPDATE_EXCEL } from '../../../services';
import Swal from 'sweetalert2';
import { openAlert } from '../../../components/alert/hooks';

export const useUpdateExcel = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (formData) => {
      try {
        const response = await POST(POST_UPDATE_EXCEL(), formData);
        return response;
      } catch (error) {
        throw { ...error, disabledThrow: true };
      }
    },
    onSuccess: () => {
      openAlert({ model: 'message', type: 'success', message: 'บันทึกข้อมูลสำเร็จ' });
    },
    meta: { hideError: true },
    onError: (error) => {
      const formattedMessage =
        error?.message
          ?.split('\n')
          .map((message, index) => {
            const divider =
              index < error.message.split('\n').length - 1
                ? '<hr style="border: none; border-top: 1px solid #e8e8e8; margin: 8px 0;">'
                : '';
            return `<div style="font-size: 13px;">${message}</div>${divider}`;
          })
          .join('') || '<div style="font-size: 13px;">ไม่สามารถบันทึกข้อมูลได้</div>';

      Swal.fire({
        icon: 'error',
        title: 'เกิดข้อผิดพลาด!',
        html: formattedMessage,
        width: '600px',
        customClass: {
          popup: 'swal2-custom-popup',
          htmlContainer: 'swal2-custom-html-container',
        },
      });
    },
  });
  return { mutate, loading: isPending };
};
